import React from 'react';

import { SHEARWAVE_OBSERVATION_COLUMNS } from './swutObservationSummary';
import { SWUTItem } from '../../forms/custom-swut/swutItemForm';

import Conditional from '../../common/conditional';
import CustomSection from '../custom-general/custom-section';
import GridItem from '../../pages/reports/general/gridItem';
import PDFTablePage from '../../themed/pdf/pdfTablePage';

import { formatTime, getChunkedData } from '../../../utils/utilities';
import { APP_DATE_FORMAT } from '../../../utils/constants';
import { SWUTObservationItem } from '../../forms/custom-swut/swutObservationItem';

import css from '../../pages/reports/pdf.module.scss';

interface Props {
	items: SWUTItem[];
}

const ShearWaveReport: React.FC<Props> = ({ items }) => {
	return (
		<>
            {items.map((item) => {
                const firstFiveObservations: SWUTObservationItem[][] = [item.observations.slice(0, 4)];
                const otherObservations: SWUTObservationItem[][] = getChunkedData(item.observations.slice(5), 25);
                const allObservations = firstFiveObservations.concat(otherObservations);


                return (
                    <React.Fragment key={item.id}>  
                        {allObservations.map((observations, index) => (
                            <CustomSection key={index} sectionTitle="Shear Wave Ultrasonic Data">
                                <div>
                                    <Conditional isVisible={index === 0}>
                                        <div className="container-fluid overflow-hidden">
                                            <div className="row">
                                                <div className="col">
                                                    <GridItem title="Surface Condition" value={item.surfaceCondition} />
                                                    <GridItem title="Surface Temperature (deg)" value={item.surfaceTemperature} />
                                                    <GridItem title="Stage of Test" value={item.stageOfTest} />
                                                    <GridItem title="Weld Joint Type" value={item.weldJointType} />
                                                    <GridItem title="Welding Type" value={item.weldType} />
                                                    <GridItem title="Welding method" value={item.weldMethod} />
                                                </div>
                
                                                <div className="col">
                                                    <GridItem title="Inspection Date" value={formatTime(item.dateOfInspection, APP_DATE_FORMAT)} />
                                                    <GridItem title="Equipment" value={item.equipment} />
                                                    <GridItem title="Serial Number" value={item.serialNumber} />
                                                    <GridItem title="Calibration Due Date" value={formatTime(item.calibrationDueDate, APP_DATE_FORMAT)} />
                                                    <GridItem title="Weld Thickness" value={item.weldThickness} />
                                                    <GridItem title="Welder ID" value={item.weldID} />
                                                </div>
                                            </div>
                                        </div>
                
                                        <div className="p-1">
                                            <PDFTablePage
                                                data={item.probes}
                                                columns={PROBE_COLUMNS}
                                            />
                                        </div>
                                        
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col">
                                                    <GridItem title="Technique" value={item.technique} />
                                                    <GridItem title="Scanning Side" value={item.scanSide} />
                                                    <GridItem title="Scan Direction" value={item.scanDirection} />
                                                </div>
                
                                                <div className="col">
                                                    <GridItem title="Couplant" value={item.couplant} />
                                                    <GridItem title="Material" value={item.material} />
                                                    <GridItem title="Scan Method" value={item.scanMethod} />
                                                </div>
                                            </div>

                                            <GridItem title="Beam Path" value={item.beamPath} />

                                            <GridItem
                                                title="Calibration Block (mm) - SD Block (As Per ASME Sec V std)"
                                                value={item.calibrationBlock}
                                            />
                                        </div>
                            
                                        <div className={css['title-grid'] + ' text-center'}></div>
                                    </Conditional>
                                    
                                    <div className="p-1">
                                        <PDFTablePage
                                            data={observations}
                                            columns={SHEARWAVE_OBSERVATION_COLUMNS}
                                        />
                                    </div>
                                </div>
                            </CustomSection>
                        ))}
                    </React.Fragment>
                );
            })}
        </>
	);
};

const PROBE_COLUMNS = [
    {
        path: 'id',
        label: 'Probe',
    },
    {
        path: 'angle',
        label: 'Angle (deg)',
    },
    {
        path: 'frequency',
        label: 'Frequency (Mhz)',
    },
    {
        path: 'size',
        label: 'Size / Dia (mm)',
    },
    {
        path: 'range',
        label: 'Range (mm)',
    },
    {
        path: 'scanVolume',
        label: 'Scanning dB',
    },
    {
        path: 'corrVolume',
        label: 'Trans Corr. dB',
    },
];

export default ShearWaveReport;
